import { FolderDocumentManager } from '../shared/FolderDocumentManager';

interface DocumentManagementProps {
  currentUserId: string;
  currentUserName?: string;
}

export function DocumentManagement({ currentUserId, currentUserName }: DocumentManagementProps) {
  return (
    <FolderDocumentManager
      userRole="administrator"
      currentUserId={currentUserId}
      currentUserName={currentUserName}
    />
  );
}
